const companyServicesInfoSelector = (state) => state.services;

export default companyServicesInfoSelector;
